<template>
  <div class="spinner-border text-secondary" role="status">
    <span class="sr-only">{{ $t('Loading') }}...</span>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
